import { RouteObject } from 'react-router-dom';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS, ROLES } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import { LogisticOperator } from '@/pages/Business/pages';

import {
  NewLogisticOperator,
  EditLogisticOperator,
  TimeSlots,
  NewTimeSlot,
  EditTimeSlot,
  NewAssignment,
  EditServiceWithOperator,
  ZonesList,
  EditZone,
  ViewZone,
  LogisticOperatorCommerces,
  NewLogisticOperatorCommerce,
  ServiceRulesConfig,
  EditServiceRulesConfig,
  Transitions,
  NewTransition,
  EditTransition,
} from '@/pages/Business/pages/LogisticOperator/pages';

import LogisticOperatorDashboard from '../LogisticOperatorDashboard';

const LogisticOperatorsRoutes: RouteObject[] = [
  {
    path: 'logistic-operator',
    element: <LogisticOperator />,
  },
  {
    path: 'logistic-operator/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <NewLogisticOperator />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:id/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <EditLogisticOperator />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/dashboard',
    element: <LogisticOperatorDashboard />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/time-slots',
    element: <TimeSlots />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/time-slots/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <NewTimeSlot />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/time-slots/:timeSlotId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <EditTimeSlot />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/services/assignments/create',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <NewAssignment />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/services/assignments/:serviceWithOperatorId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <EditServiceWithOperator />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/zones',
    element: <ZonesList />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/zones/edit/:zoneId',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.adminOrDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <EditZone />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/zones/view/:zoneId',
    element: <ViewZone />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/commerces',
    element: <LogisticOperatorCommerces />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/commerces/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <NewLogisticOperatorCommerce />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/service-rules-config',
    element: <ServiceRulesConfig />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/service-rules-config/:serviceWithOperatorId',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditServiceRulesConfig />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/transitions',
    element: <Transitions />,
  },
  {
    path: 'logistic-operator/:logisticOperatorId/transitions/new',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <NewTransition />
      </Authorize>
    ),
  },
  {
    path: 'logistic-operator/:logisticOperatorId/transitions/:transitionId/edit',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditTransition />
      </Authorize>
    ),
  },
];

export default LogisticOperatorsRoutes;
